var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLightOnOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99 16.58H3.76C3.48 16.58 3.26 16.36 3.26 16.08C3.26 15.8 3.48 15.58 3.76 15.58H8.99C9.27 15.58 9.49 15.8 9.49 16.08C9.49 16.36 9.27 16.58 8.99 16.58Z",
    fill: "#F9A704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 18.75H5.08C4.8 18.75 4.58 18.53 4.58 18.25C4.58 17.97 4.8 17.75 5.08 17.75H7.67C7.95 17.75 8.17 17.97 8.17 18.25C8.17 18.53 7.95 18.75 7.67 18.75Z",
    fill: "#F9A704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 10.92C14.1 10.92 13.04 10.52 12.24 9.71C10.63 8.1 10.63 5.48 12.24 3.87C12.44 3.67 12.75 3.67 12.95 3.87C13.15 4.07 13.15 4.38 12.95 4.58C11.73 5.8 11.73 7.79 12.95 9.01C14.17 10.23 16.16 10.23 17.38 9.01C17.97 8.42 18.3 7.63 18.3 6.8C18.3 5.97 17.97 5.18 17.38 4.59C17.18 4.39 17.18 4.08 17.38 3.88C17.58 3.68 17.89 3.68 18.09 3.88C18.87 4.66 19.3 5.7 19.3 6.8C19.3 7.9 18.87 8.94 18.09 9.72C17.31 10.5 16.23 10.93 15.17 10.93L15.16 10.92Z",
    fill: "#F9A704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.16 6.79C14.88 6.79 14.66 6.57 14.66 6.29V2.84C14.66 2.56 14.88 2.34 15.16 2.34C15.44 2.34 15.66 2.56 15.66 2.84V6.29C15.66 6.57 15.44 6.79 15.16 6.79Z",
    fill: "#F9A704"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.01 14.34H3.74C3.46 14.34 3.24 14.12 3.24 13.84C3.24 12.67 2.8 11.5 2 10.53C0.9 9.21 0.47 7.47 0.82 5.75C1.25 3.59 3 1.83 5.16 1.38C7.22 0.950004 9.26 1.62 10.63 3.17C10.81 3.38 10.79 3.69 10.59 3.88C10.38 4.06 10.07 4.04 9.88 3.84C8.75 2.56 7.06 2.01 5.36 2.36C3.59 2.73 2.15 4.17 1.8 5.95C1.51 7.37 1.87 8.81 2.77 9.9C3.6 10.91 4.11 12.11 4.22 13.34H8.53C8.63 12.06 9.1 10.9 9.88 10.02C10.06 9.81 10.38 9.79 10.59 9.98C10.8 10.16 10.82 10.48 10.63 10.69C9.91 11.5 9.52 12.62 9.52 13.85C9.52 14.13 9.3 14.35 9.02 14.35L9.01 14.34Z",
    fill: "#F9A704"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_512"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 17.5,
    fill: "white",
    transform: "translate(0.700001 1.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightOnOff);
export default __webpack_public_path__ + "static/media/lightOnOff.3fda29583371515c5519a3e37a785ee6.svg";
export { ForwardRef as ReactComponent };